// Campus photo for /colleges/university-of-oregon: CC BY 2.0, by Rick Obst, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AJohnson_Hall_on_the_University_of_Oregon_Campus_in_Eugene%2C_Oregon.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-oregon/; credited under the photo.
const photo = {
    "slug": "university-of-oregon",
    "alt": "Johnson Hall framed by trees on the University of Oregon campus in Eugene, Oregon",
    "src": "/colleges/university-of-oregon/campus-1600.webp",
    "srcSmall": "/colleges/university-of-oregon/campus-800.webp",
    "srcMid": "/colleges/university-of-oregon/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-oregon/og.jpg",
    "title": "Johnson Hall on the University of Oregon Campus in Eugene, Oregon",
    "author": "Rick Obst",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AJohnson_Hall_on_the_University_of_Oregon_Campus_in_Eugene%2C_Oregon.jpg",
    "read": "2026-10-01"
};

export default photo;
